export const ORDER_TYPE = {
  AGGREGATE: 'AGGREGATE',
  CONCRETE: 'CONCRETE',
};

export default {
  ORDER_TYPE,
};
